
export const environment = {
  production: false,
  RootDomain: "glamera.com",
  ApiUrl: "https://api-support.glamera.com/api/",
  NewApiUrl: "https://api-support-new.glamera.com/api/",
  ApiUrlV2: "https://api-support.glamera.com/api/v2/",
  UploadUrl: "https://api-support.glamera.com/api/Upload/",
  OldApiUrlFromGlamatekWeb: "https://api.glamour-plan.com/api",
  ReportDevUrl: "https://reports-support.glamera.com/",
  OnlineReportDevUrl: "https://reports-support.glamera.com/",
  SurePayUrl: 'https://localhost/Api/Merchant/v1/',
  BillingPortal: "https://subscription.glamera.com/",
  BioTimeSignalRUrl: "",
  SubscriptionAPI: "https://api-support-new.glamera.com/api/",
  ThemeBuilderApiUrl: "http://localhost:3000/", 
  baseApiUrl: 'https://api-support.glamera.com/api/his/emr/',
  GlameraProUrl: 'https://api-support.glamera.com/api/',
  version: '0.0.0',
  SignalRUrl: "https://api-realtime-support.glamera.com/"
};


